export default __webpack_public_path__ + "static/media/ic-animals-pig.2ea95d22.svg";